export default __webpack_public_path__ + "static/events-dark-4389723bd5309e5095939d2d36faf690.png";